import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConsumersComponent } from './consumers.component';

import { AgGridModule } from 'ag-grid-angular';
import { FeaturesCommonModule } from 'src/app/features-common/features-common.module';

import { ConsumersRoutingModule } from './consumers-routing.module';
import { AllConsumersComponent } from './all-consumers/all-consumers.component';
import { EditConsumerComponent } from './manage-consumers/edit-consumer/edit-consumer.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ManageConsumersComponent } from './manage-consumers/manage-consumers.component';
import { ConsumerLogsComponent } from './manage-consumers/consumer-logs/consumer-logs.component';
import { LoyaltyPointHistoryComponent } from './manage-consumers/loyalty-point-history/loyalty-point-history.component';
import { PromocodeHistoryComponent } from './manage-consumers/promocode-history/promocode-history.component';
import { EditPromocodeHistoryComponent } from './manage-consumers/promocode-history/edit-promocode-history/edit-promocode-history.component';
import { CommentsComponent } from './manage-consumers/comments/comments.component';
import { CreatecommentsComponent } from './manage-consumers/comments/createcomments/createcomments.component';
import { EditcommentComponent } from './manage-consumers/comments/editcomment/editcomment.component';
// import { PaymentHistoryComponent } from './manage-consumers/payment-history/payment-history.component';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { CustomTooltip } from 'src/app/features-common/components/tool-tip/tool-tip.component';
import { MatInputModule } from '@angular/material/input';
import { MatDialogModule } from '@angular/material/dialog';
import { Nl2BrPipeModule } from 'nl2br-pipe';
import { TransactionHistoryComponent } from './manage-consumers/transaction-history/transaction-history.component';
import { FeeConfigComponent } from './fee-config/fee-config.component';
import { AllFeeComponent } from './fee-config/all-fee/all-fee.component';
import { ConfigHistoryComponent } from './fee-config/config-history/config-history.component';
import { EditConfigHistoryComponent } from './fee-config/edit-config-history/edit-config-history.component';
import { ConsumerBannerComponent } from './consumer-banner/consumer-banner.component';
import { AddConsumerBannerComponent } from './consumer-banner/add-consumer-banner/add-consumer-banner.component';
import { EditConsumerBannerComponent } from './consumer-banner/edit-consumer-banner/edit-consumer-banner.component';
import { ManageConsumerBannerComponent } from './consumer-banner/manage-consumer-banner/manage-consumer-banner.component';
import { EditConsumerBannerSmartComponent } from './consumer-banner/edit-consumer-banner/edit-consumer-banner-smart.component';
import { AddFeeComponent } from './fee-config/add-fee/add-fee.component';
import { EditFeeComponent } from './fee-config/edit-fee/edit-fee.component';
import { ViewCommentComponent } from './manage-consumers/comments/view-comment.component';
import { PaymentReportComponent } from './manage-consumers/payment-report/payment-report.component';

@NgModule({
  declarations: [ConsumersComponent, AllConsumersComponent, EditConsumerComponent, ManageConsumersComponent, ConsumerLogsComponent, LoyaltyPointHistoryComponent, PromocodeHistoryComponent, EditPromocodeHistoryComponent, CommentsComponent, CreatecommentsComponent, EditcommentComponent, TransactionHistoryComponent, FeeConfigComponent, AllFeeComponent, ConfigHistoryComponent, EditConfigHistoryComponent, ConsumerBannerComponent, AddConsumerBannerComponent, EditConsumerBannerComponent, ManageConsumerBannerComponent, EditConsumerBannerSmartComponent, AddFeeComponent, EditFeeComponent,ViewCommentComponent, PaymentReportComponent],
  imports: [
    FeaturesCommonModule,
    ConsumersRoutingModule,
    NgxMaterialTimepickerModule,
    MatDialogModule,
    MatInputModule,
    Nl2BrPipeModule,
    AgGridModule.withComponents([CustomTooltip]),
  ]
})
export class ConsumersModule { }
